import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@material-tailwind/react';
import App from '@/App';
import './index.css';
import { Auth0Provider } from '@auth0/auth0-react';

export const domain = import.meta.env.VITE_AUTH0_DOMAIN;
export const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
export const auth0Audience = import.meta.env.VITE_AUTH0_AUDIENCE;
export const auth0Scopes = import.meta.env.VITE_AUTH0_SCOPES;
const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <Auth0Provider
    domain={domain || ' '}
    clientId={clientId || ' '}
    cacheLocation="localstorage"
    useRefreshTokens
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: auth0Audience,
      scope: auth0Scopes,
    }}
  >
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </Auth0Provider>,
);
